import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const breadcrumbItems = [{ label: '首页', to: '/' }, { label: '关于我们' }];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9sn48dlbrt1qcgaj69g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = (parsed as { meta?: { message?: string } })?.meta?.message
          || (parsed as { message?: string })?.message
          || responseText
          || '提交失败，请稍后重试';
        throw new Error(msg);
      }
    } catch (err: unknown) {
      setFormStatus('error');
      setFormError(err instanceof Error ? err.message : '提交失败，请稍后重试');
    }
  };

  const jsonLdAbout = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于奶水动画 - 母乳哺育互动动画科普平台',
    description: '了解奶水动画的品牌故事、用户口碑与联系方式，专为新手妈妈打造的母乳哺育可视化科普平台。',
    url: 'https://naishuidonghua.cn/about',
    inLanguage: 'zh-Hans',
    isPartOf: {
      '@type': 'WebSite',
      name: '奶水动画',
      url: 'https://naishuidonghua.cn/',
    },
  };

  const jsonLdFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '奶水动画是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '奶水动画是一个专为新手妈妈打造的母乳哺育可视化科普平台，通过生动直观的动画演示，帮助您了解母乳分泌原理、哺乳姿势、追奶技巧与断奶过渡。',
        },
      },
      {
        '@type': 'Question',
        name: '奶水动画平台是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，奶水动画平台所有科普内容均免费开放，我们致力于让每一位妈妈都能轻松获取科学的哺乳知识。',
        },
      },
      {
        '@type': 'Question',
        name: '动画内容是否适合中国妈妈？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容完全针对中国妈妈的实际情况编写，融合了传统哺乳智慧和现代科学研究，所有内容均为简体中文。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdAbout)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdFAQ)}</script>
      <ScrollToTop />
      <Navbar />

      <main className="pt-24 pb-14 md:pb-20">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          {/* Brand Story */}
          <section className="mt-8 mb-14">
            <div className="text-center mb-8">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                关于奶水动画
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
                用温暖的动画，传递科学的哺乳知识
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
              <div>
                <h2 className="font-heading text-xl text-foreground-900 mb-4">我们的故事</h2>
                <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                  <p>
                    奶水动画诞生于一群哺乳顾问和动画设计师的共同愿景：<strong>让每一位新手妈妈都能轻松理解母乳哺育的科学知识</strong>。
                  </p>
                  <p>
                    我们发现，很多妈妈在哺乳过程中遇到困难时，缺乏直观易懂的学习资源。纯文字的资料往往晦涩难懂，而短视频又常常碎片化、不够系统。于是，我们决定用<strong>动画演示</strong>的方式，将复杂的哺乳知识变得一目了然。
                  </p>
                  <p>
                    从<strong>奶水分泌原理</strong>到<strong>哺乳姿势教程</strong>，从<strong>追奶技巧</strong>到<strong>断奶过渡</strong>，每一段动画都经过泌乳顾问的专业审核，确保内容的科学性和准确性。
                  </p>
                  <p>
                    自上线以来，奶水动画已帮助超过<strong>50,000+</strong>位新手妈妈解决了哺乳困扰，累计播放量突破<strong>200万</strong>次。我们相信，每一个妈妈都值得被温柔对待，每一个宝宝都值得最好的喂养。
                  </p>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20soft%20illustration%20of%20mother%20and%20baby%20bonding%20moment%2C%20gentle%20nurturing%20scene%2C%20cream%20and%20soft%20rose%20watercolor%20style%2C%20minimalist%20composition%2C%20peaceful%20atmosphere%2C%20motherhood%20love%20theme&width=800&height=600&seq=about-brand-story-03&orientation=landscape"
                  alt="奶水动画品牌故事"
                  className="w-full h-full object-cover"
                  title="奶水动画 - 品牌故事"
                />
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="py-10 border-t border-background-200/70 mb-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {[
                { value: '50,000+', label: '受益妈妈' },
                { value: '200万+', label: '动画播放' },
                { value: '4', label: '科普主题' },
                { value: '30+', label: '精选文章' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Reputation */}
          <section id="reputation" className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6 text-center">
              妈妈们的真实反馈
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '小雅妈妈',
                  avatar: 'https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20portrait%20illustration%2C%20young%20Chinese%20woman%2C%20gentle%20smile%2C%20cream%20and%20rose%20tones%2C%20simple%20background&width=120&height=120&seq=avatar-xiaoya&orientation=squarish',
                  text: '作为新手妈妈，我一直很困惑奶水到底够不够。看了奶水动画的分泌原理动画后，终于明白了供需平衡的道理。现在纯母乳喂养到8个月了，感谢这个平台！',
                  role: '新手妈妈 · 母乳喂养8个月',
                },
                {
                  name: '乐乐妈妈',
                  avatar: 'https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20portrait%20illustration%2C%20young%20Chinese%20mother%2C%20warm%20expression%2C%20cream%20and%20peach%20tones%2C%20simple%20background&width=120&height=120&seq=avatar-lele&orientation=squarish',
                  text: '哺乳姿势动画教程救了我！生产后乳头皲裂疼得不行，看了正确含接姿势的动画演示后调整了姿势，一周就恢复了。动画比文字直观太多了！',
                  role: '新手妈妈 · 宝宝3个月',
                },
                {
                  name: '团团妈妈',
                  avatar: 'https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20portrait%20illustration%2C%20young%20Chinese%20woman%20with%20baby%2C%20gentle%20happy%20expression%2C%20cream%20and%20soft%20coral%20tones%2C%20simple%20background&width=120&height=120&seq=avatar-tuantuan&orientation=squarish',
                  text: '产假结束要回去上班，一直担心奶量会下降。照着追奶技巧里的Power Pumping方法坚持了一周，奶量真的上来了！现在背奶也很顺利。',
                  role: '职场妈妈 · 背奶中',
                },
              ].map((review) => (
                <div
                  key={review.name}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                      <div className="text-xs text-foreground-500">{review.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{review.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-0.5 mt-3 text-accent-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="border-t border-background-200/70 pt-14">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">联系我们</h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  如果您有任何关于母乳哺育的问题、建议或合作意向，欢迎随时与我们联系。我们的团队将尽快回复您。
                </p>
                <div className="space-y-4 text-sm">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="font-medium text-foreground-900">电子邮箱</div>
                      <span className="text-foreground-500">hello@naishuidonghua.cn</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <div>
                      <div className="font-medium text-foreground-900">微信公众号</div>
                      <span className="text-foreground-500">搜索「奶水动画」关注我们</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                      <i className="ri-time-line text-secondary-600"></i>
                    </div>
                    <div>
                      <div className="font-medium text-foreground-900">工作时间</div>
                      <span className="text-foreground-500">周一至周五 9:00 - 18:00</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6">
                <h3 className="font-heading text-lg text-foreground-900 mb-4">发送消息</h3>
                <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                  <input
                    type="text"
                    name="website_alt"
                    className="honeypot-field"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      电子邮箱
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      留言内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      rows={4}
                      required
                      maxLength={500}
                      className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                      placeholder="请输入您的留言..."
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                  </div>
                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full bg-primary-500 text-background-50 py-2.5 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i>发送中...
                      </span>
                    ) : (
                      '发送消息'
                    )}
                  </button>
                  {formStatus === 'success' && (
                    <div className="text-sm text-green-600 bg-green-50 rounded-lg px-4 py-3">
                      <i className="ri-checkbox-circle-line mr-1.5"></i>消息已发送成功，我们会尽快回复您！
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="text-sm text-red-600 bg-red-50 rounded-lg px-4 py-3">
                      <i className="ri-error-warning-line mr-1.5"></i>{formError}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}